module.exports = __webpack_public_path__ + "static/media/marau-ba.459a6ac7.jpg";